import { TfParameter, TfReportingParameterGroup } from 'api';

export const getFlattenedParams = (params: TfReportingParameterGroup[] | undefined) => {
    const paramSlugs: TfParameter[] = [];
    params?.forEach((group) => {
        group.parameters.forEach((param) => paramSlugs.push(param));
    });
    return paramSlugs;
};
